"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ZapierWebhook extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'zapierWebhook';
        this._body = initParams.body;
    }
    set body(value) {
        console.error('Do not set objects this way');
    }
    get body() {
        return this._body;
    }
}
exports.default = ZapierWebhook;
//# sourceMappingURL=zapierWebhook.js.map